import React, { Component } from 'react'
import { Box, Select, MenuItem } from '@mui/material'
export default class ShowEntries extends Component {
    /*** How to use:
     <ShowEntries value={this.state.limit} onChange={this.handleEntriesChange}/>

     handleEntriesChange(event) {
        this.setState({limit: event.target.value});
        setTimeout(() => this.fetchItems(), 100);
    }
     ***/

    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.pager.pages <= 1 && this.props.pager.items <= 10) {
            return ''
        }

        const pageSizes = [10, 20, 25, 50, 100]
        const parsedLimit = Number.parseInt(this.props.value, 10)
        const limit =
            Number.isNaN(parsedLimit) || parsedLimit < 0 || parsedLimit > 100
                ? 50
                : parsedLimit
        const options = pageSizes.includes(limit)
            ? pageSizes
            : [limit, ...pageSizes]

        return (
            <Box
                sx={{
                    float: 'right',
                }}
                className="show-entries"
            >
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    size="small"
                    name={'limit'}
                    value={limit}
                    onChange={(e) => {
                        this.props?.onChange ? this.props.onChange(e) : null
                    }}
                >
                    {options.map((pageSize) => (
                        <MenuItem key={pageSize} value={pageSize}>
                            {pageSize}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        )
    }
}
